export default __webpack_public_path__ + "static/media/logo-archdiocese_white-90.f12dd62b.png";